import axios, {AxiosResponse} from 'axios'
import {Response} from '../../../../_metronic/helpers'
import {
  DLMApplication, DLMType,
  DLMSiteInspection,
  DLMLabel,
  DLMDOC,
  DLMROI,
  DLMLabelSet,
  DLMThreshold,
  DLMSiteApplication,
  DLMSIRIdRefNo
} from './_models'

import { DLMApplicationsQueryResponse } from './context/DLMApplicationQueryResponseProvider';
import { DLMSiteInspectionsQueryResponse } from './context/DLMSiteInspectionsQueryResponseProvider';
import { DLMDOCQueryResponse } from './context/DLMDOCQueryResponseProvider';
import { DLMROIQueryResponse } from './context/DLMROIQueryResponseProvider';
import { DLMThresholdQueryResponse } from './context/DLMThresholdQueryResponseProvider';

const API_URL = process.env.REACT_APP_API_URL

const getDLMApplications = (path?: string): Promise<DLMApplicationsQueryResponse> => {

  let _type = '';
  switch(path) {
    case 'siteinspection-applications-list':
      _type = 'TYPE_SITEINSPECTION';
      break;
    case 'doc-applications-list':
      _type = 'TYPE_DOCAPPLICATION';
      break;
    case 'label-applications-list':
      _type = 'TYPE_LABELAPPLICATION';
      break;
    default:
      break;
  }

  //return axios.get(`${API_URL}/DLMApplicationServlet`)
  return axios.post(`${API_URL}/DLMApplicationListServlet`,  _type, { headers: { "Content-Type": "text/plain" }} )
  .then((res) => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}

const getAllDLMApplications = (path?: string): Promise<DLMApplicationsQueryResponse> => {

  // return axios.get(`${API_URL}/AllDLMApplicationServlet`)
  let _type = '';
  switch(path) {
    case 'siteinspection-applications-list':
      _type = 'TYPE_SITEINSPECTION';
      break;
    case 'doc-applications-list':
      _type = 'TYPE_DOCAPPLICATION';
      break;
    case 'label-applications-list':
      _type = 'TYPE_LABELAPPLICATION';
      break;
    default:
      break;
  }
  return axios.post(`${API_URL}/AllDLMApplicationServlet`,  _type, { headers: { "Content-Type": "text/plain" }} )
  .then((res) => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}

const getDLMApplicationById = (id : number): Promise<DLMApplication> => {
  // get application record
  return axios.post(`${API_URL}/DLMApplicationServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
  .then((d: AxiosResponse<DLMApplication>) => d.data)
}


// DLM Types

const getDLMTypes = (): Promise<Response<Array<DLMType>>> => {
  return axios.get(`${API_URL}/DLMTypeServlet`)
  .then( res => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}

const getDLMTypeById = (id : number, certificateId? : number ): Promise<DLMType> => {

  let payload = {id};
  if (certificateId !== undefined && certificateId > 0) {
    Object.assign(payload, { certificateId});
  }

  // get dlmtype record
  return axios.post(`${API_URL}/DLMTypeByIdServlet`,  payload)
  .then((d: AxiosResponse<DLMType>) => d.data)
  }


  // DLM Label Sets
  const getDLMLabelSets = (): Promise<Response<Array<DLMLabelSet>>> => {
  return axios.get(`${API_URL}/DLMLabelSetServlet`)
  .then( res => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}



function submitNewDLMApplication(data : any) {
  return axios.post(`${API_URL}/NewDLMApplicationServlet`, data);
}

const reassignDLMApplication = (data: any) => {
  return axios.post(`${API_URL}/ReassignDLMApplicationServlet`, data);
}

const claimDLMApplication = (applicationid: number, id: number) => {
  return axios.post(`${API_URL}/ReassignDLMApplicationServlet`, { applicationid, id })
}

const claimDLMSiteApplication = (siteApplicationid: number, id: number) => {
  return axios.post(`${API_URL}/ReassignDLMApplicationServlet`, { siteApplicationid, id })
}

const claimDLMSiteInspection = (siteApplicationid: number, id: number) => {
  return axios.post(`${API_URL}/ReassignDLMApplicationServlet`, { siteApplicationid, id })
}

function saveDraftDLMApplication(data : any) {
  return axios.post(`${API_URL}/DraftDLMApplicationServlet`, data);
}


const deleteDraftDLMApplication = (id: number): Promise<void> => {
  return axios.delete(`${API_URL}/DLMApplicationServlet?id=${id}`)
}

function submitDLMPhase_1_1(data : any) {  
  return axios.post(`${API_URL}/DLMPhase_1_1Servlet`, data);
}

function submitDLMPhase_1_2(data : any) {
  return axios.post(`${API_URL}/DLMPhase_1_2Servlet`, data);
}

function submitDLMPhase_2_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_2_1Servlet`, data);
}

function submitDLMPhase_2_2(data : any) {
  return axios.post(`${API_URL}/DLMPhase_2_2Servlet`, data);
}

function submitDLMPhase_2_3(data : any) {
  return axios.post(`${API_URL}/DLMPhase_2_3Servlet`, data);
}

function submitDLMPhase_2_4(data : any) {
  return axios.post(`${API_URL}/DLMPhase_2_4Servlet`, data);
}


function submitDLMPhase_3_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1Servlet`, data);
}

function submitDLMPhase_3_2(data : any) {  
  return axios.post(`${API_URL}/DLMPhase_3_2Servlet`, data);
}

function submitDLMPhase_3_3(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_3Servlet`, data);
}

function submitDLMPhase_3_4(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_4Servlet`, data);
}

function submitDLMPhase_3_5(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_5Servlet`, data);
}


function submitDLMPhase_4_1(data : any) {  
  return axios.post(`${API_URL}/DLMPhase_4_1Servlet`, data);
}

function submitDLMPhase_4_2(data : any) {  
  return axios.post(`${API_URL}/DLMPhase_4_2Servlet`, data);
}

function submitDLMPhase_4_3(data : any) {
  return axios.post(`${API_URL}/DLMPhase_4_3Servlet`, data);
}

function submitDLMPhase_4_4(data : any) {
  return axios.post(`${API_URL}/DLMPhase_4_4Servlet`, data);
}
function submitDLMPhase_4_5(data : any) {
  return axios.post(`${API_URL}/DLMPhase_4_5Servlet`, data);
}

function submitDLMPhase_5_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_5_1Servlet`, data);
}

function submitDLMPhase_5_2(data : any) {
  return axios.post(`${API_URL}/DLMPhase_5_2Servlet`, data);
}

function submitDLMPhase_5_3(data : any) {
  return axios.post(`${API_URL}/DLMPhase_5_3Servlet`, data);
}

function submitDLMPhase_5_4(data : any) {
  return axios.post(`${API_URL}/DLMPhase_5_4Servlet`, data);
}


function submitDLMPhase_6_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_6_1Servlet`, data);
}

function submitDLMPhase_6_2(data : any) {
  return axios.post(`${API_URL}/DLMPhase_6_2Servlet`, data);
}

function submitDLMPhase_6_3(data : any) {
  return axios.post(`${API_URL}/DLMPhase_6_3Servlet`, data);
}

function submitDLMPhase_6_4(data : any) {
  return axios.post(`${API_URL}/DLMPhase_6_4Servlet`, data);
}

function submitDLMPhase_7_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_7_1Servlet`, data);
}


function submitDLMPhase_3_1_1_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_1_1Servlet`, data);
}

function submitDLMPhase_3_1_2_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_2_1Servlet`, data);
}

function submitDLMPhase_3_1_2_2(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_2_2Servlet`, data);
}

function submitDLMPhase_3_1_2_3(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_2_3Servlet`, data);
}

function submitDLMPhase_3_1_2_4(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_2_4Servlet`, data);
}

function submitDLMPhase_3_1_3_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_3_1Servlet`, data);
}

function submitDLMPhase_3_1_4_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_4_1Servlet`, data);
}

function submitDLMPhase_3_1_4_2(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_4_2Servlet`, data);
}


function submitDLMPhase_3_1_4_3(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_4_3Servlet`, data);
}

function submitDLMPhase_3_1_4_4(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_4_4Servlet`, data);
}

function submitDLMPhase_3_1_5_1(data : any) {
  return axios.post(`${API_URL}/DLMPhase_3_1_5_1Servlet`, data);
}

function createDLMDOC(id: number) {
  return axios.post(`${API_URL}/DLMDOCCreateServlet`,  id, { headers: { "Content-Type": "text/plain" }} );
}

function generateDLMDOC(data : any) {
  return axios.post(`${API_URL}/DLMGenerateDOCServlet`, data, { responseType: 'blob' });
}

function withdrawDLMDOC(data : any) {
  return axios.post(`${API_URL}/WithdrawDOCServlet`, data);
}

function createDLMROI(id: number) {
  return axios.post(`${API_URL}/DLMROICreateServlet`,  id, { headers: { "Content-Type": "text/plain" }} );
}

function createSiteDLMROI(id: number) {
  return axios.post(`${API_URL}/DLMSiteROICreateServlet`,  id, { headers: { "Content-Type": "text/plain" }} );
}


function generateDLMROI(data : any) {
  return axios.post(`${API_URL}/DLMGenerateROIServlet`, data, { responseType: 'blob' });
}

function withdrawDLMROI(data : any) {
  return axios.post(`${API_URL}/WithdrawROIServlet`, data);
}

const getDLMSiteInspections = (): Promise<DLMSiteInspectionsQueryResponse> => {

  return axios.get(`${API_URL}/SiteInspectionServlet`)
  .then((res) => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}

const getDLMSiteInspectionById = (id : number): Promise<DLMSiteInspection> => {
  // get site inspection record
  return axios.post(`${API_URL}/SiteInspectionServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
  .then((d: AxiosResponse<DLMSiteInspection>) => d.data)
}

const searchDLMLabels = (payload : any): Promise<DLMLabel> => {  
  return axios.post(`${API_URL}/LabelListServlet`,  payload)    
  .then((d: AxiosResponse<DLMLabel>) => d.data)
}

const getDLMLabelById = (id : number): Promise<DLMLabel> => {
  // get site inspection record
  return axios.post(`${API_URL}/LabelServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
  .then((d: AxiosResponse<DLMLabel>) => d.data)
}


const getDLMDOCs = (): Promise<DLMDOCQueryResponse> => {
  return axios.get(`${API_URL}/DOCServlet`)
  .then((res) => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}

const getDLMDOCById = (id : number): Promise<DLMDOC> => {
  // get site inspection record
  return axios.post(`${API_URL}/DOCServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
  .then((d: AxiosResponse<DLMDOC>) => d.data)
}

const getDLMROIs = (): Promise<DLMROIQueryResponse> => {
  return axios.get(`${API_URL}/ROIServlet`)
  .then((res) => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}

const getDLMROIById = (id : number): Promise<DLMROI> => {
  // get site inspection record
  return axios.post(`${API_URL}/ROIServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
  .then((d: AxiosResponse<DLMROI>) => d.data)
}


function exportDLMDOC(data : any) {
  return axios.post(`${API_URL}/DOCExportServlet`, data, { responseType: 'blob' });
}

function exportDLMROI(data : any) {
  return axios.post(`${API_URL}/ROIExportServlet`, data, { responseType: 'blob' });
}

function requestDLMApplicationTermination(data : any) {
  return axios.post(`${API_URL}/TerminateDLMApplicationServlet`, data);
}

function processDLMApplicationTermination(data : any) {
  return axios.post(`${API_URL}/TerminateDLMApplicationApprovalServlet`, data);
}



const getDLMThresholds = (): Promise<DLMThresholdQueryResponse> => {
  return axios.get(`${API_URL}/ThresholdServlet`)
  .then( res => {
      // conform output to { data, payload } object.
      return {data : res.data , payload : {}};
  })
}

function setDLMThreshold(data : any) {
  return axios.post(`${API_URL}/ThresholdServlet`, data);
}

const getDLMThresholdById = (id : number): Promise<DLMThreshold> => {
  // get Threshold by ID
  return axios.post(`${API_URL}/ThresholdDetailsServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
  .then((d: AxiosResponse<DLMThreshold>) => d.data)
}


function editDLMApplication(data : any) {
  return axios.post(`${API_URL}/EditDLMApplicationServlet`, data);
}

function processDLMApplicationEditResponse(data : any) {
  return axios.post(`${API_URL}/EditDLMApplicationApprovalServlet`, data);
}

const getDLMSiteApplications = (): Promise<{ data: Array<DLMSiteApplication>}> => {

  let _type = '';
  
  //return axios.get(`${API_URL}/DLMApplicationServlet`)
  return axios.post(`${API_URL}/DLMSiteApplicationListServlet`,  _type, { headers: { "Content-Type": "text/plain" }} )
  .then((res) => {
      // conform output to { data, payload } object.
      return {data : res.data};
  })
}

const getAllDLMSiteApplications = (): Promise<{ data: Array<DLMSiteApplication>}> => {

  // return axios.get(`${API_URL}/AllDLMApplicationServlet`)
  let _type = '';
  return axios.post(`${API_URL}/AllDLMSiteApplicationServlet`,  _type, { headers: { "Content-Type": "text/plain" }} )
  .then((res) => {
      // conform output to { data, payload } object.
      return {data : res.data};
  })
}

const getSIRsByDOC = (id: number): Promise<{ data: Array<DLMSIRIdRefNo> }> => {

  return axios.post(`${API_URL}/GetSIRServlet`,  id, { headers: { "Content-Type": "text/plain" }})
  .then((res) => {    
    return (res?.data && res.data?.sirs) ? res.data.sirs : {};
  });
}

export {
  getDLMApplications, 
  getAllDLMApplications,

  getDLMApplicationById,
  getDLMTypes, getDLMTypeById,

  submitNewDLMApplication,
  reassignDLMApplication, claimDLMApplication, claimDLMSiteApplication, claimDLMSiteInspection,
  saveDraftDLMApplication, deleteDraftDLMApplication,
  submitDLMPhase_1_1,
  submitDLMPhase_1_2,
  
  submitDLMPhase_2_1,
  submitDLMPhase_2_2,
  submitDLMPhase_2_3,
  submitDLMPhase_2_4,
  
  submitDLMPhase_3_1,
  submitDLMPhase_3_2,
  submitDLMPhase_3_3,
  submitDLMPhase_3_4,
  submitDLMPhase_3_5,
  
  submitDLMPhase_4_1,
  submitDLMPhase_4_2,
  submitDLMPhase_4_3,
  submitDLMPhase_4_4,
  submitDLMPhase_4_5,

  submitDLMPhase_5_1,
  submitDLMPhase_5_2,
  submitDLMPhase_5_3,
  submitDLMPhase_5_4,
  
  submitDLMPhase_6_1,
  submitDLMPhase_6_2,
  submitDLMPhase_6_3,
  submitDLMPhase_6_4,

  submitDLMPhase_7_1,

  submitDLMPhase_3_1_1_1,
  submitDLMPhase_3_1_2_1,
  submitDLMPhase_3_1_2_2,
  submitDLMPhase_3_1_2_3,
  submitDLMPhase_3_1_2_4,
  
  submitDLMPhase_3_1_3_1,
  
  submitDLMPhase_3_1_4_1,
  submitDLMPhase_3_1_4_2,
  submitDLMPhase_3_1_4_3,
  submitDLMPhase_3_1_4_4,

  submitDLMPhase_3_1_5_1,

  createDLMDOC,
  generateDLMDOC,
  withdrawDLMDOC,
  
  createDLMROI,
  createSiteDLMROI,
  generateDLMROI,
  withdrawDLMROI,

  getDLMSiteInspections,
  getDLMSiteInspectionById,

  searchDLMLabels,
  getDLMLabelById,

  getDLMDOCs,
  getDLMDOCById,

  getDLMROIs,
  getDLMROIById,

  exportDLMDOC,
  exportDLMROI,

  requestDLMApplicationTermination,
  processDLMApplicationTermination,

  processDLMApplicationEditResponse,

  getDLMThresholds,
  setDLMThreshold,
  getDLMThresholdById,

  getDLMLabelSets,
  
  editDLMApplication,

  getDLMSiteApplications, getAllDLMSiteApplications,

  getSIRsByDOC
}